import ThemeControls from '@/components/core/Theme';
import {
	DropdownMenu,
	DropdownMenuContent,
	DropdownMenuLabel,
	DropdownMenuTrigger,
} from '@/ui/DropdownMenu';
import React from 'react';
import { Icon } from '@/ui/Icon';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { useToggle } from 'react-use';

const AccessibilityButton = observer(() => {
	const [isOpen, setOpen] = useToggle(false);
	const { i18n } = useTranslation();
	const openSettingsLabel = i18n.t('accessibility.openSettings') as string;
	const settingsPanelLabel = i18n.t('accessibility.settingsPanel') as string;

	return (
		<>
			<DropdownMenu open={isOpen} onOpenChange={setOpen}>
				<DropdownMenuTrigger asChild>
					<button
						type="button"
						aria-label={openSettingsLabel}
						title={openSettingsLabel}
						aria-expanded={isOpen}
						aria-controls="accessibility-menu"
						aria-haspopup="menu"
						data-testid="header-button-accessibility"
						className="size-[calc(24px*var(--font-scale,1))] border-0 bg-transparent p-0 text-brand-gray-3 cursor-pointer"
					>
						<Icon
							name="accessibility"
							className="size-[calc(24px*var(--font-scale,1))]"
							aria-hidden="true"
							size={24} />
					</button>
				</DropdownMenuTrigger>
				<DropdownMenuContent
					id="accessibility-menu"
					role="menu"
					aria-label={settingsPanelLabel}
				>
					<DropdownMenuLabel id="accessibility-label">
						{i18n.t('theme.title')}
					</DropdownMenuLabel>
					<ThemeControls aria-labelledby="accessibility-label"/>
				</DropdownMenuContent>
			</DropdownMenu>
		</>
	);
});

export { AccessibilityButton };
